import React from "react";
import "./errorPage.scss";

function ErrorPage() {
  return (
    <React.Fragment>
      <div className="error-page">
        <h4>Oops!</h4>
        <p>404 - PAGE NOT FOUND</p>
      </div>
    </React.Fragment>
  );
}

export default ErrorPage;
